import { create } from "zustand";

interface User {
  email: string;
  id: string;
  name: string;
  profileImage: string;
}

interface UserStoreState {
  user: User | null;
  setUser: (payload: User) => void;
  removeUser: () => void;
}

const useUserStore = create<UserStoreState>((set) => ({
  user: null,
  setUser: (payload: User) => set((state) => ({ ...state, user: payload })),
  removeUser: () => set({ user: null }),
}));

export default useUserStore;
